var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { UnsucessfulFetchError } from '../errors';
export function mapResponseToText(response) {
    return __awaiter(this, void 0, void 0, function* () {
        if (response.ok) {
            return yield response.text();
        }
        else {
            throw new UnsucessfulFetchError({
                message: yield mapResponseToMessage(response),
                response
            });
        }
    });
}
export function mapResponseToJson(response) {
    return __awaiter(this, void 0, void 0, function* () {
        if (response.ok) {
            return yield response.json();
        }
        else {
            throw new UnsucessfulFetchError({
                message: yield mapResponseToMessage(response),
                response
            });
        }
    });
}
function mapResponseToMessage(response) {
    return __awaiter(this, void 0, void 0, function* () {
        const { statusText } = response;
        const message = yield response.text();
        if (message.length > 0) {
            return `${statusText} ${message}`;
        }
        else {
            return statusText;
        }
    });
}
//# sourceMappingURL=responses.js.map